import React from 'react'
import styled from '@emotion/styled'
import { Button } from 'antd'
import { PageCrumbs } from 'components'
import { MANAGE_SCAN_PERMISSION, TRIAL } from 'utils/constants'
import { hasPermission } from 'utils/hasPermission'
import {usePayment} from 'context/payment-context';

const StyledScanSettingsTop = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 180px',
  marginBottom: 20
})

const ScanSettingsTop = ({ navigate, user }) => {
  const {setPaymentModalOpen, isTrialAccount} = usePayment();
  let isAllowed = user.permissions.filter(p => MANAGE_SCAN_PERMISSION.includes(p))

  const onCreateNewScanSettings = () => {
    isTrialAccount ? setPaymentModalOpen(true, "scan settings") : navigate('new-simple-scan');
  }

  return (
    <StyledScanSettingsTop>
      <PageCrumbs crumbs={[{ name: 'Scan Settings', icon: 'bars' }]} />
      <Button
        type="primary"
        disabled={!isAllowed.length && !isTrialAccount}
        icon="plus"
        id="newScanSettings"
        onClick={onCreateNewScanSettings}
      >
        NEW SCAN SETTINGS
      </Button>
    </StyledScanSettingsTop>
  )
}

export default ScanSettingsTop
